import React from 'react';
import { motion } from 'framer-motion';
import { heroStats } from '../data/landing';
import { CheckoutButton } from './Shared';
import { HerbSprig, LeafCluster } from './HealingIcons';
const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/nQxQLxwSm8RtPsiGeoETSs/ChatGPT_Image_12_ago_2026,_11_42_22.png',
  alt: 'Megapack Saberes Ancestrales: cinco volúmenes y tres bonus en PDF'
};
export const Hero = () => <header className="relative overflow-hidden" data-id="element-114" data-mp="128fo9ew4a5tl">
    <HerbSprig className="hidden lg:block absolute top-24 left-[3%] w-9 h-9 opacity-30 animate-float-soft" color="#2F6B34" data-id="element-115" data-mp="1274kvg6l3030" />
    <LeafCluster className="hidden lg:block absolute bottom-20 right-[4%] w-11 h-11 opacity-30 animate-float-soft" color="#C9A961" style={{
    animationDelay: '1.2s'
  }} data-id="element-116" data-mp="sa9qn9hcfluj" />

    <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 pt-6 pb-10 md:pt-16 md:pb-20 grid lg:grid-cols-2 lg:gap-x-14 items-center text-center lg:text-left" data-id="element-117" data-mp="3d1sc51sntrv8">
      {/* Headline */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-118" data-mp="3j8sfe0v2xjpu">
        <div className="inline-flex items-center gap-2 bg-white/80 border border-brand-purple/30 px-3 py-1 rounded-full mb-4 md:mb-5 shadow-sm" data-id="element-119" data-mp="399jmlbbyab52">
          <span className="text-sm" aria-hidden="true" data-id="element-120" data-mp="3eb8x8pv9gmsm">🌿</span>
          <span className="font-serif font-semibold tracking-wider text-xs md:text-sm text-brand-purpleDark" data-id="element-121" data-mp="30ggelik2qqht">
            LUMEN AKASHA™
          </span>
        </div>
        <p className="text-[10px] md:text-sm font-bold tracking-[0.12em] text-brand-goldDark mb-3 md:mb-4" data-id="element-122" data-mp="2qkmrx6cn5gmb">
          PARA TERAPEUTAS QUE TRABAJAN CON PLANTAS MEDICINALES
        </p>
        <h1 className="text-[24px] leading-[1.2] sm:text-5xl lg:text-[56px] font-bold tracking-tight" style={{
        fontFamily: "'Cinzel', serif"
      }} data-id="element-123" data-mp="2hjf81tavgibr">
          <span className="headline-shine" data-id="element-124" data-mp="2lml9mnn1hlbw">Consultas con más claridad</span>{' '}
          <span className="phrase-glow font-[800]" data-id="element-125" data-mp="s3ck463mvbog">
            y sin improvisar.
          </span>
        </h1>
      </motion.div>

      {/* Mockup */}
      <div className="lg:col-start-2 lg:row-start-1 lg:row-span-2 my-5 md:my-8 lg:my-0" data-id="element-126" data-mp="ibp18tl572yl">
        <img src={heroImage.src} alt={heroImage.alt} width={1024} height={1024} fetchPriority="high" decoding="async" className="w-full max-w-[240px] sm:max-w-md lg:max-w-none mx-auto aspect-square object-contain drop-shadow-2xl" draggable={false} data-id="element-127" data-mp="ddf4wfnolwbe" />
      </div>

      {/* Product + offer */}
      <div className="lg:col-start-1 lg:row-start-2 lg:self-start lg:mt-8" data-id="element-128" data-mp="114kjkrhvyik4">
        <h2 className="font-serif font-bold text-base md:text-2xl text-brand-purpleDark" data-id="element-129" data-mp="x0uy4awich3b">
          MEGAPACK SABERES ANCESTRALES™
        </h2>
        <p className="font-display italic text-base md:text-xl text-brand-goldDark mt-1" data-id="element-130" data-mp="3hrlp6vpyqvfb">
          Biblioteca de fitoterapia para terapeutas
        </p>

        <CheckoutButton scrollToOffer className="mt-5 w-full sm:w-auto !text-[14px] md:!text-lg !py-3.5 md:!py-5" data-id="element-131" data-mp="1xb5omas9olej">
          → QUIERO MI MEGAPACK SABERES ANCESTRALES
        </CheckoutButton>
        <p className="mt-3 text-xs md:text-sm font-medium text-brand-purpleDark" data-id="element-132" data-mp="267wj4ir67s70">
          Pago único · Sin suscripciones · Garantía de 7 días
        </p>

        <p className="text-sm md:text-lg text-brand-text mt-6 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-133" data-mp="2fyr6xrk2ezuk">
          Fichas de plantas, métodos de preparación, material sobre
          precauciones e interacciones y herramientas de seguimiento, reunidos
          para organizar tu trabajo.
        </p>

        <div className="flex flex-wrap justify-center lg:justify-start gap-2 mt-4 text-xs md:text-sm font-medium" data-id="element-134" data-mp="2tyir6a16dch0">
          <span className="inline-flex items-center bg-white px-3 py-1.5 rounded-full border border-brand-purple/20 shadow-sm" data-id="element-135" data-mp="uo0uu4cjcyr6">
            📚 5 volúmenes principales + 3 bonus
          </span>
          <span className="inline-flex items-center bg-white px-3 py-1.5 rounded-full border border-brand-purple/20 shadow-sm" data-id="element-136" data-mp="4a2y3uflxs4d">
            📄 405 páginas en PDF
          </span>
        </div>

        <p className="mt-4 text-xs md:text-sm text-brand-muted" data-id="element-137" data-mp="e88wi227gg4h">
          Para consultar en celular, tablet o computadora e imprimir las
          páginas que necesites.
        </p>

        <dl className="mt-6 md:mt-8 pt-5 md:pt-6 border-t border-brand-purple/15 grid grid-cols-4 gap-x-2 md:gap-x-3 max-w-xl mx-auto lg:mx-0" data-id="element-138" data-mp="3hph7q32fghq8">
          {heroStats.map(s => <div key={s.label} className="text-center lg:text-left" data-id="element-139" data-mp="3rglpfajhmgor">
              <dt className="sr-only" data-id="element-140" data-mp="3rhwt7acxnofv">{s.label}</dt>
              <dd className="font-serif font-bold text-lg md:text-2xl text-brand-purple leading-none" data-id="element-141" data-mp="3moc2829rbuq6">
                {s.value}
              </dd>
              <dd className="text-[10px] md:text-xs text-brand-muted mt-1 leading-tight" data-id="element-142" data-mp="2yxg3el6vvz9f">
                {s.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </div>
  </header>;